import { createGlobalStyle } from "styled-components";

/*
 * Skip Link Target Styles:
 * Remove default focus outline from skip link target elements
 */
export const SkipLinkTargetStyles = createGlobalStyle`
  #oetal-application-root[tabindex="-1"]:focus,
  #page[tabindex="-1"]:focus {
    outline: none;
  }
`;
